// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"240":"c0cad8a2","300":"28012cb8","340":"50fc7381","536":"eebba3ae","652":"491ab9ff","841":"9f7ff362","962":"8992a986","973":"25d83a96"}[chunkId] + ".chunk.js";
};